__turbopack_context__.v({
  "entryContainer": "checkout-module__ZvRnCG__entryContainer",
  "heading": "checkout-module__ZvRnCG__heading",
  "logos": "checkout-module__ZvRnCG__logos",
  "mainPanel": "checkout-module__ZvRnCG__mainPanel",
  "sidePanel": "checkout-module__ZvRnCG__sidePanel",
});
